export default __webpack_public_path__ + "static/media/activities.e1e4de23.svg";